import { ParameterType } from '@/study-search/enums';
import { IIndexation } from '../../../interfaces';
import { FilterKey, AttendanceFilterOptionValue } from '@studyportals/search-filters/server-side';
import { Filter } from '../Filter';

export class AttendanceFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.DELIVERY_METHOD, ParameterType.DELIVERY_METHOD, []);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1 && this.values.includes(AttendanceFilterOptionValue.ONLINE)
		|| this.values.length === 1 && this.values.includes(AttendanceFilterOptionValue.BLENDED);
	}
}
